import { useEffect, useState } from "react"

import { type ActivityStatusDto, getActivityStatus } from "@/services/core"
import { useRoleInfo } from "@/user/session"

export const useActivityStatus = () => {
    const user = useRoleInfo()
    const [data, setData] = useState<ActivityStatusDto | undefined>(undefined)

    useEffect(() => {
        if (!user) {
            setData(undefined)
            return
        }
        getActivityStatus().then((res) => {
            if (res.code === 0) setData(res.data)
        })
    }, [user])

    return { data }
}
